import { getBaseUrlByEnv } from '@/constants/baseUrls';

/**
 * @deprecated The method should not be used for new components.
 * use isInternalLink instead.
 */
export const openLinkCurrentTab = (link: string) => {
  if (link === undefined) return true;
  const isExternal =
    link.startsWith('/') ||
    link.startsWith('#') ||
    link.startsWith('https://careers.sunrun.com/us/en') ||
    link.startsWith('https://www.sunrun.com') ||
    link.startsWith(getBaseUrlByEnv());

  return isExternal;
};

export const isInternalLink = (href: string | undefined) => {
  if (!href) return true;
  return href.startsWith('/');
};

export const isSpecialLink = (href: string | undefined) => {
  if (!href) return false;
  return (
    href.startsWith('#') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')
  );
};

export function removeLeadingSlash(str: string) {
  return str.replace(/^\//, '');
}

const BLOB_BLURB_LENGTH_CHARS = 100;

export function getBlogBlurb(text: string) {
  return text.slice(0, BLOB_BLURB_LENGTH_CHARS) + '...';
}

const templateReplaceRegex = new RegExp(/\{\{.*?\}\}/g, 'g');
export const replaceTemplate = (str: string, value: string) => {
  return str.replace(templateReplaceRegex, value);
};

export const stringHasTemplate = (str: string) =>
  str.match(templateReplaceRegex) !== null;
